import { UserRolesType } from "@/app/model/types";
import { FC, useState } from "react";
import styles from "./ResetPasswordButton.module.scss";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { recoveryPassword } from "@/entities/users/slice";
import { IUser } from "@/entities/users/types";

interface ResetPasswordButtonProps {
  currentUser: IUser;
  roleName: UserRolesType;
}

export const ResetPasswordButton: FC<ResetPasswordButtonProps> = ({
  currentUser,
  roleName,
}) => {
  const dispatch = useAppDispatch();
  const [resType, setResType] = useState<"default" | "ok" | "err">("default");

  const { isLoading } = useAppSelector((state) => state.users);
  const onSubmitRecovery = async () => {
    if (isLoading) {
      return;
    }

    const res = await dispatch(recoveryPassword({ email: currentUser.email }));
    if (recoveryPassword.fulfilled.match(res)) {
      setResType("ok");
    } else if (recoveryPassword.rejected.match(res)) {
      setResType("err");
    }
  };

  return roleName === "TechAdmin" ||
    roleName === "Admin" ||
    roleName === "Dealer" ? (
    <div className={styles.resetPassMain}>
      {isLoading && (
        <span className={styles.spin}>
          <Spin indicator={<LoadingOutlined />} size="default" />
        </span>
      )}
      {resType === "default" && <p onClick={onSubmitRecovery}>Сброс пароля</p>}
      {resType === "ok" && (
        <span className={styles.success}>Письмо отправлено</span>
      )}
      {resType === "err" && <p>Ошибка</p>}
    </div>
  ) : (
    <></>
  );
};
